import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { data, useLocation, useNavigate } from "react-router-dom";
import MediaUpload from "../../../components/Forms/MediaUpload";
import { useGetChallengeCategoriesList, useGetChallengeList } from "../../../queries/challenge";
import { ActionButton } from "../../../components/Forms/ActionButton";
import { useCreateFact, useGetFactDetails, useUpdateFact } from "../../../queries/facts";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateFact = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const factId = state?.factId;

    const [active, setActive] = useState(true);
    const [showInHomePage, setShowInHomePage] = useState(false);
    // const [showInBlogsPage, setShowInBlogsPage] = useState(false);
    const [coverImage, setCoverImage] = useState(null);
    const [fileId, setFileId] = useState(null);
    const [filteredChallengeList, setFilteredChallengeList] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [mediaClear, setMediaClear] = useState(false);

    const { data: challengeCategoryList, isPending: isChallengeCategoryPending } = useGetChallengeCategoriesList();
    const { data: challengeList, isPending: isChallengeListPending } = useGetChallengeList();

    const { data: factDetails, isLoading } = useGetFactDetails(factId);

    const { mutateAsync, isPending: isCreating } = useCreateFact();
    const { mutateAsync: updateFact, isPending: isEditing } = useUpdateFact();
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
    } = useForm({
        defaultValues: {
            title: factDetails ? factDetails.title : "",
            description: factDetails ? factDetails.description : "",
        }
    });

    const onSubmit = async (data) => {
        console.log('🔍 [CreateFact] onSubmit called');
        console.log('🔍 [CreateFact] coverImage type:', coverImage instanceof File ? 'File' : typeof coverImage);
        console.log('🔍 [CreateFact] coverImage:', coverImage);
        console.log('🔍 [CreateFact] fileId:', fileId);

        if (factId) {
            toast.loading('Updating Fact...');
            updateFact({
                id: factId,
                title: data.title,
                description: data.description,
                connectedChallenge: data.connectedChallenge,
                showInHomePage: showInHomePage,
                file: coverImage,
                fileId: fileId,
                isActive: active,
            }, {
                onSuccess: () => {
                    console.log('✅ [CreateFact] Update success - navigating to fact list');
                    toast.dismiss();
                    toast.success('Fact Updated Successfully!');
                    reset();
                    setCoverImage(null);
                    setTimeout(() => {
                        console.log('🚀 [CreateFact] Navigating to /fact-details/list-facts');
                        navigate('/fact-details/list-facts');
                    }, 2000);
                },
                onError: (err) => {
                    console.error('❌ [CreateFact] Update error:', err);
                    toast.dismiss();
                    toast.error('Something Went Wrong!');
                }
            });
        } else {
            toast.loading('Creating Fact...');
            mutateAsync({
                title: data.title,
                description: data.description,
                connectedChallenge: data.connectedChallenge,
                showInHomePage: showInHomePage,
                file: coverImage,
            }, {
                onSuccess: () => {
                    console.log('✅ [CreateFact] Create success - navigating to fact list');
                    toast.dismiss();
                    toast.success('Fact Created Successfully!');
                    reset();
                    setCoverImage(null);
                    setTimeout(() => {
                        console.log('🚀 [CreateFact] Navigating to /fact-details/list-facts');
                        navigate('/fact-details/list-facts');
                    }, 2000);
                },
                onError: (err) => {
                    console.error('❌ [CreateFact] Create error:', err);
                    toast.dismiss();
                    toast.error('Something Went Wrong!');
                }
            });
        }
    }

    useEffect(() => {
        if (factDetails) {
            const categoryId = factDetails?.connectedChallenge?.category?._id || factDetails?.connectedChallenge?.category || "";
            setValue("title", factDetails?.title);
            setValue("description", factDetails?.description);
            setValue("challengeCategory", categoryId);
            setSelectedCategoryId(categoryId); // this will trigger the challenge filtering useEffect
            setActive(factDetails?.isActive);
            setShowInHomePage(factDetails?.showInHomePage);
            setCoverImage(factDetails?.imageUrl);
            setFileId(factDetails?.fileId || factDetails?.imageId);
        }
    }, [factDetails, isLoading]);

    useEffect(() => {
        setTimeout(() => {
            if (factDetails) {
                setCoverImage(factDetails.imageUrl);
                setValue("description", factDetails.description || "");
            }
        }, 100);
    }, [factDetails]);

    useEffect(() => {
        setMediaClear(false);
    }, [coverImage]);
    
    useEffect(() => {
        if (factDetails && selectedCategoryId && filteredChallengeList.length) {
            const challengeId = factDetails?.connectedChallenge?._id;
            const exists = filteredChallengeList.some(c => c._id === challengeId);
            if (exists) {
                setValue("connectedChallenge", challengeId);
            }
        }
    }, [filteredChallengeList]);

    // useEffect(() => {
    //     // setValue("challengeCategory", factDetails?.connectedChallenge?.category || "");
    //     handleCategoryChange({target: { value: factDetails?.connectedChallenge?.category?._id || factDetails?.connectedChallenge?.category || "" }});
    //     setValue("connectedChallenge", factDetails?.connectedChallenge?._id);
    // }, [challengeList, selectedCategoryId]);

    // Add this useEffect to filter challenges when category changes
    useEffect(() => {
        if (selectedCategoryId && challengeList) {
            const filtered = challengeList.filter(challenge =>
                challenge.category?._id === selectedCategoryId || challenge.category === selectedCategoryId
            );
            setFilteredChallengeList(filtered);
        } else {
            setFilteredChallengeList(challengeList || []);
        }
    }, [selectedCategoryId, challengeList]);

    // Handle challenge category change
    const handleCategoryChange = (e) => {
        const categoryId = e.target.value;
        setSelectedCategoryId(categoryId);
        setValue("challengeCategory", categoryId);
        setValue("connectedChallenge", ""); // reset challenge on category change
    };
    if (isLoading || isChallengeCategoryPending || isChallengeListPending) {
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-gray-500">Loading...</p>
            </div>
        );
    }

    return (
        <form className="flex flex-col w-full font-semibold " onSubmit={handleSubmit(onSubmit)}>
            <section className="flex flex-col justify-center px-5 pt-2 py-9 gap-3 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                <div className="flex items-center justify-between">
                    <p className="text-base font-bold mt-3">Fact Information</p>
                    <div className="flex gap-3 items-center">
                        <p className="text-base">Status:</p>
                        <div className={`flex justify-end items-center border ${active ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                            <label className="inline-flex items-center me-5 cursor-pointer h-full">
                                <span className={`ms-3 text-base ${active ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{active ? 'Active' : 'Inactive'}</span>
                                <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                                <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col w-full gap-4">
                        {/* Fact Title */}
                        <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-1.5">
                            <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Fact Title</label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    placeholder="Fact Title"
                                    {...register("title", { required: "Title is required" })}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.title ? "border-red-500" : ""}`}
                                />
                            </div>
                            {errors.title && <p className="text-red text-sm">{errors.title.message}</p>}
                        </div>
                        {/* Description */}
                        <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[150px] w-full mt-1.5">
                            <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Description</label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <textarea
                                    type="text"
                                    placeholder="Enter Description of Fact"
                                    {...register("description", { required: "Description is required" })}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.description ? "border-red-500" : ""}`}
                                    rows={5}
                                />
                            </div>
                            {errors.description && <p className="text-red text-sm">{errors.description.message}</p>}
                        </div>
                        {/* Select page */}
                        <div className="flex flex-col flex-1 grow shrink-0 basis-0 w-full mt-1.5">
                            <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Select The Page  To Show Fact</label>
                            <div className="flex items-center mt-1 min-h-10 px-3 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400 gap-5">
                                <div>
                                    <input type="checkbox" name="showInHomePage" id="" value={showInHomePage} checked={showInHomePage || false} onChange={() => setShowInHomePage(!showInHomePage)} />
                                    <span className="ml-2">Home Page</span>
                                </div>
                                {/* <div>
                                    <input type="checkbox" name="showInBlogsPage" id="" value={showInBlogsPage} onChange={() => setShowInBlogsPage(!showInBlogsPage)} />
                                    <span className="ml-2">Blogs</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* Cover Image */}
                    <div className="mt-0">
                        <MediaUpload
                            clearMedia={mediaClear}
                            label={"Thumbnail"}
                            existingImage={coverImage}
                            setImageUpload={setCoverImage}
                            stateImage={coverImage}
                            setStateImageUpload={setCoverImage}
                            useFileObject={true}
                        />
                    </div>
                </div>
                <h1 className="text-primary text-2xl font-bold mt-3">Link a Challenge</h1>
                <div>
                    {/* Challenge category */}
                    <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-1.5">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Challenge Category</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register("challengeCategory")}
                                onChange={handleCategoryChange}
                                className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.challengeCategory ? "border-red-500" : ""}`}
                            >
                                <option value="">Select Challenge Category</option>
                                {challengeCategoryList?.map((category) => (
                                    <option key={category?._id} value={category?._id}>
                                        {category?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {errors.challengeCategory && <p className="text-red text-sm">{errors.challengeCategory.message}</p>}
                    </div>
                    {/* Challenge Name */}
                    <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-4">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Challenge Name</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register("connectedChallenge")}
                                className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.connectedChallenge ? "border-red-500" : ""}`}
                            // disabled={!selectedCategoryId}
                            >
                                <option value="">Select Challenge</option>
                                {filteredChallengeList.map((challenge) => (
                                    <option key={challenge?._id} value={challenge?._id}>
                                        {challenge?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {errors.connectedChallenge && <p className="text-red text-sm">{errors.connectedChallenge.message}</p>}
                    </div>
                </div>

                {/* Buttons */}
                <div className="mt-10 flex gap-5 items-center justify-between">
                    <ActionButton
                        variant="reset"
                        text="Reset"
                        handleSubmit={() => {
                            reset();
                            setCoverImage(null);
                            setMediaClear(true);
                            setShowInHomePage(false);
                            setActive(true);
                        }}
                    />
                    <div className="flex items-center gap-3">
                        <ActionButton
                            variant="cancel"
                            text="Cancel"
                            handleSubmit={() => navigate('/fact-details/list-facts')}
                        />
                        <ActionButton
                            variant="submit"
                            text="Save"
                            // onClick={() => reset()}
                            disabled={isCreating
                                // || isEditingBlog
                            }
                        />
                    </div>
                </div>
            </section>
            <ToastContainer
                position="top-right"
            />
        </form>
    );
}

export default CreateFact;